import React from 'react';
import { Card, CardContent } from './Card';
import { Progress } from './Progress';
import { BoxIcon } from 'lucide-react';
interface KPICardProps {
  title: string;
  value: string | number;
  icon: BoxIcon;
  colorVar: string;
  trend?: {
    value: string;
    label: string;
    isPositive?: boolean;
  };
  progress?: {
    value: number;
    label: string;
    target: string;
  };
  onClick?: () => void;
}
export function KPICard({
  title,
  value,
  icon: Icon,
  colorVar,
  trend,
  progress,
  onClick
}: KPICardProps) {
  return <Card className={`glass-panel border-l-4 cursor-pointer hover:bg-white/5 transition-colors`} style={{
    borderLeftColor: colorVar
  }} onClick={onClick} data-id="element-389">
      <CardContent className="p-4" data-id="element-390">
        <div className="flex justify-between items-start" data-id="element-391">
          <div data-id="element-392">
            <p className="text-[10px] font-mono text-muted-foreground uppercase tracking-wider mb-1" data-id="element-393">
              {title}
            </p>
            <div className="text-3xl font-heading font-bold" style={{
            color: colorVar,
            textShadow: `0 0 10px color-mix(in srgb, ${colorVar} 50%, transparent)`
          }} data-id="element-394">
              {value}
            </div>
          </div>
          <div className="p-2 rounded" style={{
          backgroundColor: `color-mix(in srgb, ${colorVar} 10%, transparent)`
        }} data-id="element-395">
            <Icon className="w-5 h-5" style={{
            color: colorVar
          }} data-id="element-396" />
          </div>
        </div>

        {trend && <div className="mt-4 flex items-center gap-2" data-id="element-397">
            <span className="text-xs font-mono" style={{
          color: trend.isPositive !== false ? 'var(--status-active)' : 'var(--destructive)'
        }} data-id="element-398">
              {trend.value}
            </span>
            <span className="text-[10px] font-mono text-muted-foreground" data-id="element-399">
              {trend.label}
            </span>
          </div>}

        {progress && <div className="mt-4" data-id="element-400">
            <div className="flex justify-between text-[10px] font-mono mb-1" data-id="element-401">
              <span className="text-muted-foreground" data-id="element-402">{progress.label}</span>
              <span style={{
            color: colorVar
          }} data-id="element-403">
                {progress.target}
              </span>
            </div>
            <Progress value={progress.value} className="h-1 bg-secondary" data-id="element-404" />
          </div>}
      </CardContent>
    </Card>;
}